import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import Button from "@material-ui/core/Button";
import { logOut } from "./authActions";
import { notBlank } from "../util/ext";
import Grid from "@material-ui/core/Grid";
import UserProfileSwitchOrgsMenu from "../components/UserProfileSwitchOrgsMenu";

const useStyles = makeStyles(theme => ({
  container: {
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "white",
  },

  header: {
    fontSize: "3rem",
    color: theme.palette.error.main,
  },

  message: {
    fontSize: "1.6rem",
    color: theme.palette.error.main,
  },
}));

const Unauthorized = props => {
  const { message } = props;
  const classes = useStyles();
  const reduxDispatch = useDispatch();
  const auth = useSelector(state => state.auth);

  const [openMenu, setOpenMenu] = useState(false);
  const handleToggleMenu = () => setOpenMenu(!openMenu);

  return (
    <div className={classes.container}>
      <h1 className={classes.header}>Unauthorized!</h1>
      <h4 className={classes.message}>{message}</h4>

      {notBlank(auth) && (
        <Grid container justify="center">
          <Button
            variant="text"
            color="primary"
            onClick={() => reduxDispatch(logOut())}
          >
            Log Out
          </Button>

          <UserProfileSwitchOrgsMenu
            onClose={handleToggleMenu}
            closeDropDown={() => setOpenMenu(false)}
          />
        </Grid>
      )}
    </div>
  );
};

export default Unauthorized;
